module.exports = __webpack_public_path__ + "assets/img/upload-item.63217860.png";